import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from './admin/admin.component';
import { BrandDetailComponent } from './brand-detail/brand-detail.component';
import { BrandsComponent } from './brands/brands.component';
import { CreateLeadComponent } from './create-lead/create-lead.component';
import { CreateOrderComponent } from './create-order/create-order.component';
import { CreateUserComponent } from './create-user/create-user.component';
import { CustomerApprovalComponent } from './customer-approval/customer-approval.component';
import { CustomerCompliantComponent } from './customer-compliant/customer-compliant.component';
import { CustomerDetailsComponent } from './customer-details/customer-details.component';
import { CustomerVisitDetailsComponent } from './customer-visit-details/customer-visit-details.component';
import { CustomerVisitsComponent } from './customer-visits/customer-visits.component';
import { CustomersComponent } from './customers/customers.component';
import { DepartmentComponent } from './department/department.component';
import { EditBrandComponent } from './edit-brand/edit-brand.component';
import { EditCustomerComponent } from './edit-customer/edit-customer.component';
import { EditEmloyeeComponent } from './edit-emloyee/edit-emloyee.component';
import { EditFolderComponent } from './edit-folder/edit-folder.component';
import { EditLeadsComponent } from './edit-leads/edit-leads.component';
import { EditProductComponent } from './edit-product/edit-product.component';
import { EditUserComponent } from './edit-user/edit-user.component';
import { EmployeeDetailsComponent } from './employee-details/employee-details.component';
import { EmployeeManagementComponent } from './employee-management/employee-management.component';
import { FolderComponent } from './folder/folder.component';
import { HomeComponent } from './home/home.component';
import { InvoiceDetailsComponent } from './invoice-details/invoice-details.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { LeadsComponent } from './leads/leads.component';
import { LoginComponent } from './login/login.component';
import { MachineComponent } from './machine/machine.component';
import { ProductAdviceViewComponent } from './product-advice-view/product-advice-view.component';
import { ProductAdviceComponent } from './product-advice/product-advice.component';
import { ProductCompliantComponent } from './product-compliant/product-compliant.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { ProductStockComponent } from './product-stock/product-stock.component';
import { ProductionDetailsComponent } from './production-details/production-details.component';
import { ProductionsComponent } from './productions/productions.component';
import { ProductsComponent } from './products/products.component';
import { ReceiptsDetailsComponent } from './receipts-details/receipts-details.component';
import { ReceiptsComponent } from './receipts/receipts.component';
import { SaleOrderDetailsComponent } from './sale-order-details/sale-order-details.component';
import { SaleOrdersComponent } from './sale-orders/sale-orders.component';
import { SalesPojectionComponent } from './sales-pojection/sales-pojection.component';
import { SingleUserDetailComponent } from './single-user-detail/single-user-detail.component';
import { StockDetailComponent } from './stock-detail/stock-detail.component';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { UserprivilegeComponent } from './userprivilege/userprivilege.component';
// import { AddWorkingDaysComponent } from './add-working-days/add-working-days.component';
// import { DepartmentWsViewComponent } from './department-ws-view/department-ws-view.component';
// import { DepartmentWsEditComponent } from './department-ws-edit/department-ws-edit.component';
import { SalesTeamComponent } from './sales-team/sales-team.component';
import { SalesTeamCreationComponent } from './sales-team-creation/sales-team-creation.component';
import { SalesTeamViewComponent } from './sales-team-view/sales-team-view.component';
import { SalesTeamEditComponent } from './sales-team-edit/sales-team-edit.component';
import { EditDepartmentComponent } from './edit-department/edit-department.component';
import { DepartmentDetailComponent } from './department-detail/department-detail.component';
import { EmployeeAttendenceComponent } from './employee-attendence/employee-attendence.component';
import { KycComponent } from './kyc/kyc.component';
// import { CrmComponent } from './crm/crm.component';
// import { RFRComponent } from './crm/rfr/rfr.component';
import { EmployeeKpiComponent } from './employee-kpi/employee-kpi.component';
import { MarketingVisitComponent } from './marketing-visit/marketing-visit.component';
import { MarketStudyComponent } from './market-study/market-study.component';

import { SalesPromoterReportComponent } from './reports/sales-promoter-report/sales-promoter-report.component';
import { AttendanceRequestComponent } from './attendance-request/attendance-request.component';
import { UserWorkingdaysComponent } from './user-workingdays/user-workingdays.component';
import { UserWorkingdaysListComponent } from './user-workingdays-list/user-workingdays-list.component';
import { UserWorkingdaysEditComponent } from './user-workingdays-edit/user-workingdays-edit.component';
import { UserWorkingdaysViewComponent } from './user-workingdays-view/user-workingdays-view.component';
import { MarketSyudyComponent } from './market-syudy/market-syudy.component';
import { MarketStudyJebelaliComponent } from './market-study-jebelali/market-study-jebelali.component';
import { EmployeeKpiEditComponent } from './employee-kpi-edit/employee-kpi-edit.component';
import { AlqousbmMarketStudyComponent } from './alqousbm-market-study/alqousbm-market-study.component';
import { NepalMarketStudyComponent } from './nepal-market-study/nepal-market-study.component';
import { NepalautomativeMarketStudyComponent } from './nepalautomative-market-study/nepalautomative-market-study.component';
import { SalesmanReportComponent } from './reports/salesman-report/salesman-report.component';
import { KpiRequestRevertListComponent } from './kpi-request-revert-list/kpi-request-revert-list.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FactoryProjectionComponent } from './factory-projection/factory-projection.component';
import { FactoryProjectionListingComponent } from './factory-projection-listing/factory-projection-listing.component';
import { FactoryProjectionCreateComponent } from './factory-projection-create/factory-projection-create.component';
import { MarketingCampaignComponent } from './marketing-campaign/marketing-campaign.component';
import { QatarMarketStudyComponent } from './qatar-market-study/qatar-market-study.component';
import { FactoryMenuComponent } from './factory-menu/factory-menu.component';
import { EmployeeKpiDetailsComponent } from './employee-kpi-details/employee-kpi-details.component';
import { WarehouseComponent } from './warehouse/warehouse.component';
import { ReportsModule } from './reports/reports.module';
import { MeetingModule } from './meeting/meeting.module';
import { AuthenticationGuard } from './Auth/authentication.guard';
import { LoginGuard } from './Auth/login.guard';
import { MarketingModule } from './marketing/marketing.module';
import { OopsComponent } from './shared/utilities/components/oops/oops.component';
import { AttendanceRequestEditComponent } from './attendance-request-edit/attendance-request-edit.component';
import { EmployeeAttendenceDetailsComponent } from './employee-attendence/employee-attendence-details/employee-attendence-details.component';
import { SummaryReportComponent } from './external-page/summary-report/summary-report.component';
import { MarketStudyInsideComponent } from './market-study-inside/market-study-inside.component';
import { MarketStudyDecorativeComponent } from './market-study-decorative/market-study-decorative.component';
import { MarketStudyOthersComponent } from './market-study-others/market-study-others.component';
import { EmployeeAttendanceBetaComponent } from './employee-attendance-beta/employee-attendance-beta.component';
import { EmployeeAttendanceBetaDetailsComponent } from './employee-attendance-beta/employee-attendance-beta-details/employee-attendance-beta-details.component';
import { ShiftAssignmentComponent } from './employee-attendance-beta/shift-assignment-master/shift-assignment/shift-assignment.component';
import { DepartmentListComponent } from './employee-attendance-beta/shift-assignment-master/department-list/department-list.component';
import { DepartmentEditPageComponent } from './department-edit-page/department-edit-page.component';
import { WebPunchingComponent } from './web-punching/web-punching.component';
import { KpiMonthlyReportsComponent } from './kpi-monthly-report/kpi-monthly-reports/kpi-monthly-reports.component';
import { MasterForRfrListingComponent } from './master-for-rfr/master-for-rfr-listing/master-for-rfr-listing.component';
import { MasterForRfrEditComponent } from './master-for-rfr/master-for-rfr-edit/master-for-rfr-edit.component';
import { ViewLeaveRequestComponent } from './Leave-Request/view-leave-request/view-leave-request.component';
import { EditLeaveRequestComponent } from './Leave-Request/edit-leave-request/edit-leave-request.component';
import { DetailLeaveRequestComponent } from './Leave-Request/detail-leave-request/detail-leave-request.component';
import { CreateTempUserComponent } from './user-detail/create-temp-user/create-temp-user.component';
import { DepartmentMasterListingComponent } from './department-master/department-master-listing/department-master-listing.component';
import { DepartmentMasterEditComponent } from './department-master/department-master-edit/department-master-edit.component';
import { ExcludedRfrUsersListingComponent } from './excluded-rfr-users-master/excluded-rfr-users-listing/excluded-rfr-users-listing.component';
import { ExcludedRfrUsersEditComponent } from './excluded-rfr-users-master/excluded-rfr-users-edit/excluded-rfr-users-edit.component';
import { AiChatPageComponent } from './ai-assistant/ai-chat-page/ai-chat-page.component';
const routes: Routes = [
  { path: '', component: LoginComponent, canActivate: [LoginGuard] },
  { path: 'home', component: HomeComponent },
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [AuthenticationGuard],
    children: [
      {
        path: 'employee-management', component: EmployeeManagementComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'dashboard', component: DashboardComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'products', component: ProductsComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'product-details', component: ProductDetailsComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'customer-visit', component: CustomerVisitsComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'customer-details', component: CustomerDetailsComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'employee-details', component: EmployeeDetailsComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'edit-product', component: EditProductComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'edit-employee', component: EditEmloyeeComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'customer-visit-details',
        component: CustomerVisitDetailsComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'customer', component: CustomersComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'invoices', component: InvoicesComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'invoice-detail', component: InvoiceDetailsComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'receipts', component: ReceiptsComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'receipts-detail', component: ReceiptsDetailsComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'edit-customer', component: EditCustomerComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'customer-compliant', component: CustomerCompliantComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'product-complaint', component: ProductCompliantComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'user-detail', component: UserDetailComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'create-user', component: CreateUserComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'create-temp-user', component: CreateTempUserComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'brands', component: BrandsComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'brand-details', component: BrandDetailComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'edit-brand', component: EditBrandComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'single-user-detail', component: SingleUserDetailComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'user-privileges', component: UserprivilegeComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'leads', component: LeadsComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'edit-leads', component: EditLeadsComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'create-lead', component: CreateLeadComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'edit-user', component: EditUserComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'sale-orders', component: SaleOrdersComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'create-order', component: CreateOrderComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'order-detail', component: SaleOrderDetailsComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'product-advice', component: ProductAdviceComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'product-advice-view', component: ProductAdviceViewComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'folder', component: FolderComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'machine', component: MachineComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'edit-folder', component: EditFolderComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'customer-approval', component: CustomerApprovalComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'sales-projection', component: SalesPojectionComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'productions', component: ProductionsComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'Factory', component: FactoryMenuComponent,
        canActivate: [AuthenticationGuard]
      },


      {
        path: 'production-details', component: ProductionDetailsComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'product-stock', component: ProductStockComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'stock-detail', component: StockDetailComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'department', component: DepartmentComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'Warehouse', component: WarehouseComponent,
        canActivate: [AuthenticationGuard]
      },
      //  {path:'kpi-menu',component:KpiMenuComponent},
      //  {path:'add-working-days',component:AddWorkingDaysComponent},
      //  {path:'add-working-view',component:DepartmentWsViewComponent},
      //  {path:'add-working-edit',component:DepartmentWsEditComponent},
      {
        path: 'sales-team', component: SalesTeamComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'sales-team-creation', component: SalesTeamCreationComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'sales-team-view', component: SalesTeamViewComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'sales-team-edit', component: SalesTeamEditComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'edit-department', component: EditDepartmentComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'department-edit-page', component: DepartmentEditPageComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'department-detail', component: DepartmentDetailComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'employee-attendence', component: EmployeeAttendenceComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'employee-attendance-beta', component: EmployeeAttendanceBetaComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'Web-Punching', component: WebPunchingComponent,
        canActivate: [AuthenticationGuard]
      },
      {
  path: 'customer-survey-menu',
  loadChildren: () =>
    import('./customer-survey/customer-survey.module').then(
      (m) => m.CustomerSurveyModule
    ),
  canActivate: [AuthenticationGuard]
},    {
        path: 'employee-attendance-beta-details', component: EmployeeAttendanceBetaDetailsComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'shift-assignment', component: ShiftAssignmentComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'department-list', component: DepartmentListComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'KYC', component: KycComponent,
        canActivate: [AuthenticationGuard]
      },
      //  {path:'CRM',component:CrmComponent},
      //  {path:'RFR',component:RFRComponent},
      {
        path: 'employee-kpi', component: EmployeeKpiComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'marketing-visit', component: MarketingVisitComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'market-study-inside', component: MarketStudyInsideComponent,  
        canActivate: [AuthenticationGuard]
      },
      { path: 'market-study-decorative', component: MarketStudyDecorativeComponent },
      { path: 'market-study-others', component: MarketStudyOthersComponent },

      {
        path: 'marketing_campaign', component: MarketingCampaignComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'Attendance-request', component: AttendanceRequestComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'Attendance-request-edit', component: AttendanceRequestEditComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'Leave-request-view', component: ViewLeaveRequestComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'Leave-request-edit', component: EditLeaveRequestComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'Leave-request-detail', component: DetailLeaveRequestComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'user-working-days', component: UserWorkingdaysComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'user-working-days-list',
        component: UserWorkingdaysListComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'user-working-days-edit',
        component: UserWorkingdaysEditComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'user-working-days-view',
        component: UserWorkingdaysViewComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'market-study', component: MarketSyudyComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'jebel-ali-market-study',
        component: MarketStudyJebelaliComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'employee-kpi-edit', component: EmployeeKpiEditComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'Aqousbm-market-study', component: AlqousbmMarketStudyComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'nepal-market-study', component: NepalMarketStudyComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'nepalautomotive-market-study',
        component: NepalautomativeMarketStudyComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'qatar-market-study', component: QatarMarketStudyComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'kpi-request-revert', component: KpiRequestRevertListComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'factory-projection', component: FactoryProjectionComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'factory-projection-listing',
        component: FactoryProjectionListingComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'factory-projection-create',
        component: FactoryProjectionCreateComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'employee-kpi-details',
        component: EmployeeKpiDetailsComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'CRM',
        loadChildren: () => import('./crm/crm.module').then(
          (m) => m.CrmModule),
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'Factory',
        loadChildren: () =>
          import('./factory/factory.module').then(
            (m) => m.FactoryModule),
        canActivate: [AuthenticationGuard]
      },
      {
         path: 'Mixing',
         loadChildren: () =>
         import('./mixing/mixing.module').then(
         (m) => m.MixingModule),
         canActivate: [AuthenticationGuard],
         data: { defaultRoute: 'mixing-workbench-detail' }
      },
      {
        path: 'mixing-ii',
        loadChildren: () =>
         import('./mixing-ii/mixing-ii.module').then(m => m.MixingIiModule)
       },

      {
        path: 'kpi-menu',
        loadChildren: () => import('./kpi/kpi.module').then(
          (m) => m.KpiModule),
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'master-menu',
        loadChildren: () =>
          import('./masters/masters.module').then(
            (m) => m.MastersModule),
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'hrm-menu',
        loadChildren: () => import('./hrm/hrm.module').then(
          (m) => m.HrmModule),
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'new-hrm-menu',
        loadChildren: () => import('./hrm-new/hrm-new.module').then(
          (m) => m.HrmModule),
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'rfr-responsible-listing',
        component: MasterForRfrListingComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'rfr-edit-page',
        component: MasterForRfrEditComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'department-master-listing',
        component: DepartmentMasterListingComponent,
        canActivate: [AuthenticationGuard]
      },

      {
        path: 'department-master-edit',
        component: DepartmentMasterEditComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'excluded-rfr-users-listing',
        component: ExcludedRfrUsersListingComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'excluded-rfr-users-edit',
        component: ExcludedRfrUsersEditComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'message-menu',
        loadChildren: () =>
          import('./messaging-broadcast/messaging-broadcast.module').then(
            (m) => m.MessagingBroadcastModule
          ), canActivate: [AuthenticationGuard]
      },
      {
        path: 'settings-menu',
        loadChildren: () =>
          import('./settings/settings.module').then(
            (m) => m.SettingsModule),
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'operation',
        loadChildren: () =>
          import('./operations/operations.module').then(
            (m) => m.OperationsModule
          ), canActivate: [AuthenticationGuard]
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./reports/reports.module').then(
            (m) => m.ReportsModule), canActivate: [AuthenticationGuard]
      },
      {
    path: 'kpi-monthly-report',
    component: KpiMonthlyReportsComponent,
    canActivate: [AuthenticationGuard]
},
      {
        path: 'Meeting',
        pathMatch: 'full',
        redirectTo: '/admin/Meeting/monthly-meeting-report-listing'
      },
      {
        path: 'Meeting',
        loadChildren: () =>
          import('./meeting/meeting.module').then(
            (m) => m.MeetingModule), canActivate: [AuthenticationGuard]
      },
      {
        path: 'Marketing',
        loadChildren: () =>
          import('./marketing/marketing.module').then(
            (m) => m.MarketingModule), canActivate: [AuthenticationGuard]
      },
      {
        path: 'complaint',
        loadChildren: () =>
          import('./complaint/complaint.module').then(
            (m) => m.ComplaintModule), canActivate: [AuthenticationGuard]
      },
      {
        path: 'employee-attendence-detail', component: EmployeeAttendenceDetailsComponent
      },
      {
        path: 'ai-assistant', component: AiChatPageComponent,
        canActivate: [AuthenticationGuard]
      },

    ],
  },
  {
    path: 'summary-report/:id', component: SummaryReportComponent
  },
  // Wildcard route for unmatched paths
  { path: '**', component: OopsComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }